<template>
    <div>
        <div id="create-campaign">
            <div class="app-container my-5" v-show="!$global.loading">

                <div class="mb-3 d-flex justify-content-between">
                    <div class="page-title">
                        <router-link to="/veille/vtc">
                            <span class="breadcrumb-link">
                                <v-icon class="breadcrumb-link-icon">search</v-icon> Veille
                            </span>
                        </router-link>
                        <v-icon>keyboard_arrow_right</v-icon>
                        <span class="breadcrumb-item">
                            <v-icon class="breadcrumb-item-icon">mdi-plus-circle</v-icon> Suivre de nouveaux prestataires
                        </span>
                    </div>

                    <div class="d-flex">
                        <div class="mr-3">
                            <div>
                              <span class="font-weight-bold">
                                {{providersTotal}} / {{vtcMaxProvidersCount}} prestataires
                            </span>
                            </div>
                            <div class="text-right text-black-50">
                               <span v-if="availablePlaces > 1">
                                {{availablePlaces}} places restantes
                            </span>
                                <span v-else>
                                {{availablePlaces}} place restante
                            </span>
                            </div>
                        </div>
                        <v-progress-circular
                          :size="60"
                          :value="complationRate"
                          :color="complationRate === 100 ? 'warning' : 'primary'"
                        >
                            {{Math.round(complationRate)}} %
                        </v-progress-circular>
                    </div>
                </div>

                <v-stepper @change="setAddProStep" non-linear :value="addProStep">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Sélection
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Validation prestataires
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Contact
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            Finaliser
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <vtc-filters></vtc-filters>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <vtc-providers-selection></vtc-providers-selection>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <vtc-email-verification></vtc-email-verification>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <vtc-finalize></vtc-finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import VtcFilters from "./steppers/VtcFilters.vue"
import VtcEmailVerification from "./steppers/VtcEmailVerification.vue"
import VtcProvidersSelection from "./steppers/VtcProvidersSelection.vue"
import VtcFinalize from "./steppers/VtcFinalize.vue"

export default {
    name: "VtcAddProviders",
    components: { VtcFilters, VtcEmailVerification, VtcProvidersSelection, VtcFinalize },
    data() {
        return {
            complationRate: 0,
            providersTotal: 0,
            availablePlaces: 0,
        }
    },
    methods: {
        ...mapMutations("vtc", [
            "setAddProStep",
            "setVtc",
            "resetState",
            'setVtcMaxProvidersCount',
        ]),
        getVtc() {
            let payload = {
                accountId: this.account.id,
            }

            this.$http.post("/veille-tourisme/vtc", payload).then((res) => {
                if (res.body.success && res.body.data.vtc !== null) {
                    this.setVtc(res.body.data.vtc)
                    this.setTotals()
                }
            })
        },
        setTotals() {
            this.complationRate = (this.vtc.providers_count / this.vtcMaxProvidersCount) * 100
            this.providersTotal = this.vtc.providers_count
            this.availablePlaces = this.vtcMaxProvidersCount - this.vtc.providers_count
        }
    },
    computed: {
        ...mapState("account", ["account"]),
        ...mapState("vtc", [
            "vtc",
            "addProStep",
            'vtcMaxProvidersCount',
            'providersToAdd',
        ]),
    },
    watch: {
        providersToAdd() {
            if(this.vtc.id) {
                this.complationRate =
                  ((this.vtc.providers_count + this.providersToAdd.length)/ this.vtcMaxProvidersCount) * 100
                this.providersTotal = this.vtc.providers_count + this.providersToAdd.length
                this.availablePlaces = this.vtcMaxProvidersCount - (this.vtc.providers_count + this.providersToAdd.length)
            } else {
                this.complationRate =
                  (this.providersToAdd.length / this.vtcMaxProvidersCount) * 100
                this.providersTotal = this.providersToAdd.length
                this.availablePlaces = this.vtcMaxProvidersCount - this.providersToAdd.length
            }
        },
    },
    created() {
        this.$store.dispatch("account/fetchCategories")
        this.$store.dispatch("account/fetchCommunes")
        this.resetState()

        if (!this.vtc.id) {
            this.getVtc()
        } else {
            this.setTotals()
        }

        if(this.account.configurations.vtMaxCapacity) {
            this.setVtcMaxProvidersCount(this.account.configurations.vtMaxCapacity)
        }
    },
}
</script>